import { Container, Grid, Group, Image, Stack, Text, Title } from '@mantine/core';
import LogHistory from 'modules/pages/lcms/courseEntry/LogHistory';
import BasicInformation from 'modules/pages/lcms/courseCombineTNA/BasicInformation';
import DeliveryDetails from 'modules/pages/lcms/courseCombineTNA/DeliveryDetails';
// import Facilitator from 'modules/pages/lcms/courseCombineTNA/Facilitator';
import IndicatorStandards from 'modules/pages/lcms/courseCombineTNA/IndicatorStandards';
import React from 'react';
import MaterialInput from 'modules/pages/lcms/courseEntry/MaterialInput';
import { useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { courseService } from 'services/lcms/course.service';
import { MaterialData, PICCourseData } from 'types/lcms/courses';
import BrokenApprovalCourseLink from 'modules/external/approvalCourse/BrokenApprovalCourseLink';
import LoaderApprovalCourse from 'modules/external/approvalCourse/LoaderApprovalCourse';
import ScheduleSection from 'modules/pages/lcms/courses/ScheduleSection';

const SMECourseEntryPage = () => {
  const [searchParams] = useSearchParams();
  const hashKey = searchParams.get('h');

  const { data, isPending, isError } = useQuery({
    queryKey: ['getSMESubmitDetail', hashKey],
    queryFn: () => courseService.getSMESubmitDetail({ h: hashKey as string }),
    enabled: !!hashKey
  });

  const courseId = data?.data?.course?.id;
  const dataCourse: PICCourseData = data?.data?.course;
  const dataListMaterial: MaterialData[] = data?.data?.listMaterial;
  // const dataPIC: PICData = data?.data?.pic;

  const { data: dataDetailCourse, isPending: loadingDetailCourse } = useQuery({
    queryKey: ['courseDetail', courseId],
    queryFn: () => courseService.detail(courseId),
    enabled: !!courseId
  });

  return (
    <Container fluid maw={1440} py={'xl'}>
      <Group mb={'lg'} gap={4}>
        <Image src='/logo/logo_icon-dacum.svg' h={32} w={32} />
        <Text fz={24} fw={800} c={'dark'}>
          LCMS
        </Text>
      </Group>
      {isError && <BrokenApprovalCourseLink />}
      {isPending && !isError && <LoaderApprovalCourse />}
      {!isPending && !isError && data && (
        <>
          <Stack gap={0}>
            <Text fz={'sm'} fw={600} c={'gray'}>
              Entry Material
            </Text>
            <Title order={2} mb={30}>
              {dataCourse?.name}
            </Title>
          </Stack>
          <Grid>
            <Grid.Col span={8}>
              <Stack gap={16}>
                <MaterialInput dataListMaterial={dataListMaterial} hashKey={hashKey as string} />

                <BasicInformation
                  beelajarID={data?.data?.beelajarID}
                  basicInformation={dataDetailCourse?.data?.data?.basicInformation}
                  loading={loadingDetailCourse}
                />
                <DeliveryDetails
                  data={dataDetailCourse?.data?.data?.deliveryDetails}
                  loading={loadingDetailCourse}
                />
                <IndicatorStandards
                  data={dataDetailCourse?.data?.data?.indicatorStandards}
                  loading={loadingDetailCourse}
                />
                {/* <Facilitator dataPIC={dataPIC} loading={loadingDetailCourse} /> */}
              </Stack>
            </Grid.Col>
            <Grid.Col span={4} pos={'relative'}>
              <Stack gap={16} pos={'sticky'} top={16}>
                <ScheduleSection data={dataDetailCourse?.data?.data?.basicInformation} />
                <LogHistory data={dataDetailCourse?.data?.data?.version} />
              </Stack>
            </Grid.Col>
          </Grid>
        </>
      )}
    </Container>
  );
};

export default SMECourseEntryPage;
